import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  clientname,
  currentTenant,
  dataaccess,
  financialyearstart,
  logo,
  thousandsdisplay,
  userid,
  userwhid,
} from "../../Common/Credentials";
import InventoryService from "../InventoryService";
import moment from "moment";
import { spin } from "../../Common/NewLoader.jsx";
import { inventoryid } from "../../Common/Permissions";
import { NumericFormat } from "react-number-format";
import {
  Box,
  Collapse,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  TextField,
  IconButton,
  Tooltip,
  MenuItem
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SalesServices from "../../Sales/SalesServices.js";
import ProductionServices from "../../Production/ProductionServices.js";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import EditIcon from "../../images/Icons/edit.png"
import ViewIcon from "../../images/Icons/preview.png";
import UpArrow from "../../images/Icons/up-arrow.png";
import '../../NewUI/NewUI.css'
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

const StockDataTable = ({ navigate }) => {
  const [stock, setStock] = useState([]);
  const [itemstock, setItemstock] = useState([]);
  const [itemstockdata, setItemstockdata] = useState([]);
  const [thirdpartystockdata, setThirdpartystockdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemid, setItemid] = useState("");
  const [itemname, setItemname] = useState("");
  const [type, setType] = useState("Stock Details");
  const [stocktype, setStocktype] = useState("Own Stock");
  const [batchstockdata, setBatchstockdata] = useState([]);
  const [salesconsumptiondata, setSalesconsumptiondata] = useState([]);
  const [productionconsumptiondata, setProductionconsumptiondata] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [fromdate, setFromdate] = useState(moment().subtract(7, "days"));
  const [todate, setTodate] = useState(moment());
  const [hovered, setHovered] = useState(null);
  const [isActionHovered, setIsActionHovered] = useState(false);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const [products, setProducts] = useState({});
  const [currentView, setCurrentView] = useState('list');
  const [selectedStock, setSelectedStock] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filteredSidebarData, setFilteredSidebarData] = useState([]);
  const [hasScrolledToSelected, setHasScrolledToSelected] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  // NEW: Separate sort configs for detail view tables
  const [sortConfigStockDetails, setSortConfigStockDetails] = useState({ key: 'date', direction: 'desc' });
  const [sortConfigStockConsumption, setSortConfigStockConsumption] = useState({ key: 'custombatchid', direction: 'asc' });
  const sidebarRef = React.useRef(null);
  const scrollTimeout = React.useRef(null);

  // NEW: Sort indicator component
  const SortIndicator = ({ columnKey, currentSortConfig }) => {
    if (currentSortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return currentSortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  };

  // Sorting function
  const sortData = (key, configSetter, currentConfig) => {
    let direction = 'asc';
    if (currentConfig.key === key && currentConfig.direction === 'asc') {
      direction = 'desc';
    }
    configSetter({ key, direction });
  };

  // Get sorted data - generic function
  const getSortedData = (data, sortConfig) => {
    if (!sortConfig || !sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (sortConfig.key) {
        case 'name':
          aValue = a.name || '';
          bValue = b.name || '';
          break;
        case 'brand':
          aValue = a.brand || '';
          bValue = b.brand || '';
          break;
        case 'model':
          aValue = a.model || '';
          bValue = b.model || '';
          break;
        case 'totalStock':
          aValue = a.totalStock || 0;
          bValue = b.totalStock || 0;
          break;
        case 'currentStock':
          aValue = a.currentStock || 0;
          bValue = b.currentStock || 0;
          break;
        case 'fifo':
          aValue = a.fifo || 0;
          bValue = b.fifo || 0;
          break;
        case 'avg':
          aValue = a.avg || 0;
          bValue = b.avg || 0;
          break;
        case 'lifo':
          aValue = a.lifo || 0;
          bValue = b.lifo || 0;
          break;
        case 'supplier':
          aValue = a.supplier || '';
          bValue = b.supplier || '';
          break;
        case 'warehouse':
          aValue = a.warehouse || a.waddress || '';
          bValue = b.warehouse || b.waddress || '';
          break;
        case 'stocktype':
          aValue = STOCKTYPE_LABELS[a.stocktype] || a.stocktype || '';
          bValue = STOCKTYPE_LABELS[b.stocktype] || b.stocktype || '';
          break;
        case 'date':
          aValue = a.date ? new Date(a.date).getTime() : 0;
          bValue = b.date ? new Date(b.date).getTime() : 0;
          break;
        case 'cost':
          aValue = a.cost || 0;
          bValue = b.cost || 0;
          break;
        case 'rate':
          aValue = a.rate || 0;
          bValue = b.rate || 0;
          break;
        case 'vendorBatchCode':
          aValue = a.vendorBatchCode || '';
          bValue = b.vendorBatchCode || '';
          break;
        case 'custombatchid':
          aValue = a.custombatchid || '';
          bValue = b.custombatchid || '';
          break;
        case 'addedStock':
          aValue = a.addedStock || 0;
          bValue = b.addedStock || 0;
          break;
        case 'consumedStock':
          aValue = a.consumedStock || 0;
          bValue = b.consumedStock || 0;
          break;
        case 'batchstock':
          aValue = a.batchstock || 0;
          bValue = b.batchstock || 0;
          break;
        case 'stockfrom':
          aValue = a.stockfrom || '';
          bValue = b.stockfrom || '';
          break;
        case 'poid':
          aValue = a.poid || '';
          bValue = b.poid || '';
          break;
        case 'grnid':
          aValue = a.grnid || '';
          bValue = b.grnid || '';
          break;
        default:
          aValue = a[sortConfig.key] || '';
          bValue = b[sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  // NEW: Search highlighting methods
  const escapeRegex = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightSearchText = (text, searchTerm) => {
    if (!searchTerm.trim() || !text) return text;

    const regex = new RegExp(`(${escapeRegex(searchTerm)})`, 'gi');
    const parts = String(text).split(regex);

    return parts.map((part, index) =>
      regex.test(part)
        ? React.createElement('mark', {
          key: index,
          className: "UI-search-highlight"
        }, part)
        : part
    );
  };

  // NEW: Format currency as string for highlighting
  const formatCurrencyAsString = (value) => {
    if (value === null || value === undefined) return '0';

    // Format the number with thousand separators and 2 decimal places
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  // Handle resize
  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    if (!mobile) {
      setShowSearch(false);
    }
  };

  const refreshStocks = useCallback(() => {
    setLoading(true);

    InventoryService.retriveStock(currentTenant)
      .then((response) => {
        const sortedStock = response.data.sort((a, b) => (a.date < b.date ? 1 : -1));
        setStock(sortedStock);
        Data(sortedStock);
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate("/");
        }
      })
      .finally(() => {
        setLoading(false);
      });

    InventoryService.GetThirdpartystock(currentTenant)
      .then((response) => {
        setThirdpartystockdata(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate("/");
        }
      });
  }, [navigate]);

  const Data = (data) => {
    const products = data.reduce((item, stockItem) => {
      if (!item[stockItem.name]) item[stockItem.name] = [];
      item[stockItem.name].push(stockItem);
      return item;
    }, {});

    setProducts(products);

    // Calculate total sales by products
    let stockdata = [];
    Object.entries(products).forEach(([key, value]) => {
      let a = {
        name: key,
        id: value.map((e) => e.id)[0],
        brand: value.map((e) => e.brand)[0],
        model: value.map((e) => e.model)[0],
        uomname: value.map((e) => e.uomname)[0],
        totalStock: value.map((e) => e.totalStock)[0],
        avg: value.reduce((a, v) => (a = a + v.rate), 0) / value.length,
        fifo: value.sort((a, b) => (a.date > b.date ? 1 : -1)).map((e) => e.rate)[0],
        lifo: value.sort((a, b) => (a.date < b.date ? 1 : -1)).map((e) => e.rate)[0],
      };
      stockdata.push(a);
    });
    setItemstockdata(stockdata);
  };

  const handleselect = (data, value) => {
    setItemid(data);
    setItemname(value);
    setType("Stock Details");
    setSelectedStock({ id: data, name: value });
    setCurrentView('detail');
    setFilteredSidebarData(getFilteredData()); // Set filtered sidebar data

    const filteredStock = stock.filter((e) => e.id === data);
    setItemstock(filteredStock);

    let datadao = {
      tenantid: currentTenant,
      startdate: moment().subtract(7, "days"),
      enddate: moment(),
      userid: userid,
      dataaccess: dataaccess,
      whid: userwhid,
      id: "",
      itemid: data,
    };

    InventoryService.getbyitemforconsumption(datadao).then((response) => {
      setBatchstockdata(response.data.sort((a, b) => (a.batchid > b.batchid ? 1 : -1)));

      let datadao2 = {
        tenantid: currentTenant,
        startdate: moment().subtract(7, "days"),
        enddate: moment(),
        userid: userid,
        dataaccess: dataaccess,
        whid: userwhid,
        id: "",
        itemid: data,
        list: response.data.map(e => e.batchid)
      };

      SalesServices.getdelivereditems(datadao2).then((response) =>
        setSalesconsumptiondata(response.data)
      );

      ProductionServices.Storeaddedquantity(datadao2).then((response) =>
        setProductionconsumptiondata(response.data)
      );
    });
  };

  const handleFromDateChange = (date) => {
    setFromdate(date);
    if (moment(date).diff(todate, "days") >= 0) {
      setTodate(date);
    }
  };

  const handleToDateChange = (date) => {
    setTodate(date);
  };

  const STOCKTYPE_LABELS = {
    INTERNALUSE: "INTERNAL USE",
    RESALE: "RESALE",
    RAWMATERIAL: "RAW MATERIAL",
    FINISHEDPRODUCT: "FINISHED PRODUCT",
  };

  const Submit = () => {
    let datadao = {
      tenantid: currentTenant,
      startdate: fromdate,
      enddate: todate,
      userid: userid,
      dataaccess: dataaccess,
      whid: userwhid,
      id: "",
      itemid: itemid
    };

    InventoryService.getbyitemforconsumption(datadao).then((response) => {
      setBatchstockdata(response.data.sort((a, b) => (a.batchid > b.batchid ? 1 : -1)));

      let datadao2 = {
        tenantid: currentTenant,
        startdate: fromdate,
        enddate: todate,
        userid: userid,
        dataaccess: dataaccess,
        whid: userwhid,
        id: "",
        itemid: itemid,
        list: response.data.map(e => e.batchid)
      };

      SalesServices.getdelivereditems(datadao2).then((response) =>
        setSalesconsumptiondata(response.data)
      );

      ProductionServices.Storeaddedquantity(datadao2).then((response) =>
        setProductionconsumptiondata(response.data)
      );
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (!userid) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      navigate("/");
      return;
    }

    setLoading(true);
    refreshStocks();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [navigate, refreshStocks]);

  useEffect(() => {
    // Auto-scroll in detail view (only once)
    if (currentView === 'detail' && selectedStock && sidebarRef.current && !hasScrolledToSelected) {
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      scrollTimeout.current = setTimeout(() => {
        const selectedElement = sidebarRef.current.querySelector(`[data-stock-id="${selectedStock.id}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setHasScrolledToSelected(true);
        }
      }, 100);
    }
  }, [currentView, selectedStock, hasScrolledToSelected]);

  // Get filtered data based on search term
  const getFilteredData = () => {
    let data = stocktype === "Own Stock" ? itemstockdata : thirdpartystockdata;

    if (!searchTerm.trim()) {
      return data;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return data.filter(item =>
      item.name?.toLowerCase().includes(lowerSearchTerm) ||
      item.brand?.toLowerCase().includes(lowerSearchTerm) ||
      item.model?.toLowerCase().includes(lowerSearchTerm) ||
      (item.totalStock?.toString().includes(searchTerm)) ||
      (item.avg?.toString().includes(searchTerm))
    );
  };

  const filteredData = getSortedData(getFilteredData(), sortConfig); // Apply sorting to filtered data

  // Update filtered sidebar data when search term changes in detail view
  useEffect(() => {
    if (currentView === 'detail') {
      setFilteredSidebarData(getSortedData(getFilteredData(), sortConfig));
    }
  }, [searchTerm, currentView, itemstockdata, thirdpartystockdata, stocktype, sortConfig]);

  // Get current page data for pagination
  const getCurrentPageData = () => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredData.slice(indexOfFirstItem, indexOfLastItem);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedStock(null);
    setItemid("");
    setHasScrolledToSelected(false);
  };

  // Get sorted batch data for consumption table
  const getSortedBatchData = () => {
    return getSortedData(batchstockdata, sortConfigStockConsumption);
  };

  const Row = ({ row, salesconsumptiondata, productionconsumptiondata }) => {
    const [open, setOpen] = useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className={open ? "bg-light" : ""}>
          <TableCell>
            {salesconsumptiondata.length > 0 || productionconsumptiondata.length > 0 ? (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            ) : ""}
          </TableCell>
          <TableCell component="th" scope="row">
            {highlightSearchText(row.custombatchid, searchTerm)}
          </TableCell>
          {/* NEW: Vendor Batch Code Column */}
          <TableCell>
            {highlightSearchText(row.vendorBatchCode || "N/A", searchTerm)}
          </TableCell>
          <TableCell>{highlightSearchText(row.stockfrom === "Production" ? "Production" : (row.supplier === undefined || row.supplier === null || row.supplier === "" ? (row.byproduct === true ? "By Product" : "Opening") : row.supplier), searchTerm)}</TableCell>
          <TableCell style={{ color: "green" }}>{highlightSearchText(row.addedStock?.toString(), searchTerm)}</TableCell>
          <TableCell style={{ color: row.currentStock < 3 ? "red" : "green" }}>{highlightSearchText(row.currentStock?.toString(), searchTerm)}</TableCell>
          <TableCell>{highlightSearchText(STOCKTYPE_LABELS[row.stocktype] ?? row.stocktype, searchTerm)}</TableCell>
          <TableCell>
            {highlightSearchText(
              formatCurrencyAsString(row.rate),
              searchTerm
            )}
          </TableCell>
          <TableCell>{highlightSearchText(row.stockfrom, searchTerm)}</TableCell>
          <TableCell>{highlightSearchText(row.stockfrom === "Purchase" ? row.poid + " / " + row.grnid : "", searchTerm)}</TableCell>
          <TableCell>{highlightSearchText(row.waddress, searchTerm)}</TableCell>
          <TableCell>{highlightSearchText(moment(row.date).format("DD-MM-YYYY HH:mm"), searchTerm)}</TableCell>
        </TableRow>
        <TableRow className={open ? "bg-light" : ""}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
                  <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
                    <thead className="UI-table-header">
                      <tr>
                        <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Consumption In</th>
                        {salesconsumptiondata.length > 0 && (
                          <>
                            <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Customer</th>
                            <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Invoice Id/No</th>
                            <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Delivery Note</th>
                          </>
                        )}
                        {productionconsumptiondata.length > 0 && (
                          <>
                            <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Store</th>
                            <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Workcenter/Production Unit</th>
                          </>
                        )}
                        <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Quantity</th>
                        <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Price</th>
                        <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}>Consumption Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {salesconsumptiondata?.map((historyRow, i) => (
                        <tr key={i} className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''}`}>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText("Sales", searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.customer, searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.invid, searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.dnid, searchTerm)}</td>
                          {productionconsumptiondata.length > 0 && (
                            <>
                              <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.store, searchTerm)}</td>
                              <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.workcenter, searchTerm)}</td>
                            </>
                          )}
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.quantity?.toString(), searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                            {highlightSearchText(
                              formatCurrencyAsString(historyRow.price),
                              searchTerm
                            )}
                          </td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(moment(historyRow.date).format("DD-MM-YYYY HH:mm"), searchTerm)}</td>
                        </tr>
                      ))}
                      {productionconsumptiondata?.map((historyRow, i) => (
                        <tr key={i} className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''}`}>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText("Production", searchTerm)}</td>
                          {salesconsumptiondata.length > 0 && (
                            <>
                              <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.customer, searchTerm)}</td>
                              <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.invid, searchTerm)}</td>
                              <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.dnid, searchTerm)}</td>
                            </>
                          )}
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.store, searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.workcenter, searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(historyRow.quantity?.toString(), searchTerm)}</td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                            {highlightSearchText(
                              formatCurrencyAsString(historyRow.price),
                              searchTerm
                            )}
                          </td>
                          <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(moment(historyRow.date).format("DD-MM-YYYY HH:mm"), searchTerm)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  const MainTable = () => {
    const currentPageData = getCurrentPageData();

    if (filteredData.length === 0) {
      return (
        <div className={`UI-no-data-message ${isMobile ? 'UI-no-data-message-mobile' : ''}`}>
          {searchTerm ? 'No stock items found matching your search' : 'No stock items available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'name' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('name', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Item Name
                    <SortIndicator columnKey="name" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'brand' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('brand', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Brand
                    <SortIndicator columnKey="brand" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'model' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('model', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Model/Grade
                    <SortIndicator columnKey="model" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'totalStock' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('totalStock', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Total Stock
                    <SortIndicator columnKey="totalStock" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'fifo' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('fifo', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    FIFO Price
                    <SortIndicator columnKey="fifo" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'avg' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('avg', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Average Price
                    <SortIndicator columnKey="avg" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'lifo' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('lifo', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    LIFO Price
                    <SortIndicator columnKey="lifo" currentSortConfig={sortConfig} />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentPageData.map((row) => (
                <tr
                  key={row.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${hoveredRow === row.id ? (isMobile ? '' : 'UI-table-row-hovered') : ''}`}
                  onClick={() => handleselect(row.id, row.name)}
                  onMouseEnter={() => setHoveredRow(row.id)}
                  onMouseLeave={() => {
                    setHoveredRow(null);
                    setHoveredAction(null);
                  }}
                >
                  {/* Item Name Cell */}
                  <td
                    className={`UI-td UI-item-name ${isMobile ? 'UI-td-mobile' : ''} ${hoveredRow === row.id ? 'UI-item-name-hover' : ''}`}
                  >
                    <Tooltip
                      title="View Details"
                      placement="right"
                      arrow
                      slotProps={{
                        popper: {
                          sx: { pointerEvents: 'none' },
                        },
                      }}
                      open={!isMobile && hoveredRow === row.id && !hoveredAction}
                    >
                      <span>{highlightSearchText(row.name, searchTerm)}</span>
                    </Tooltip>
                  </td>

                  {/* Brand Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} ${hoveredRow === row.id ? 'UI-brand-hover' : ''}`}
                  >
                    {highlightSearchText(row.brand || "NA", searchTerm)}
                  </td>

                  {/* Model Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} ${hoveredRow === row.id ? 'UI-brand-hover' : ''}`}
                  >
                    {highlightSearchText(row.model || "NA", searchTerm)}
                  </td>

                  {/* Total Stock Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{
                      color: row.totalStock < 3 ? "red" : "green",
                      fontWeight: hoveredRow === row.id ? 600 : 400,
                    }}
                  >
                    {highlightSearchText(row.totalStock?.toString(), searchTerm)}
                  </td>

                  {/* FIFO Price Cell */}
                  <td className={`UI-td UI-price-high ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(
                      formatCurrencyAsString(row.fifo),
                      searchTerm
                    )}
                  </td>

                  {/* Average Price Cell */}
                  <td className={`UI-td UI-price-high ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(
                      formatCurrencyAsString(row.avg),
                      searchTerm
                    )}
                  </td>

                  {/* LIFO Price Cell */}
                  <td className={`UI-td UI-price-high ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(
                      formatCurrencyAsString(row.lifo),
                      searchTerm
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {renderPagination()}
      </>
    );
  };

  const ThirdPartyTable = () => {
    const currentPageData = getCurrentPageData();

    if (filteredData.length === 0) {
      return (
        <div className={`UI-no-data-message ${isMobile ? 'UI-no-data-message-mobile' : ''}`}>
          {searchTerm ? 'No third party stock items found matching your search' : 'No third party stock items available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'name' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('name', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Item Name
                    <SortIndicator columnKey="name" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('supplier', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Supplier
                    <SortIndicator columnKey="supplier" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'brand' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('brand', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Brand
                    <SortIndicator columnKey="brand" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'model' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('model', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Model/Grade
                    <SortIndicator columnKey="model" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'warehouse' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('warehouse', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Org Unit
                    <SortIndicator columnKey="warehouse" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'currentStock' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('currentStock', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Current Stock
                    <SortIndicator columnKey="currentStock" currentSortConfig={sortConfig} />
                  </div>
                </th>
                {/* NEW: Vendor Batch Code Column */}
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'vendorBatchCode' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('vendorBatchCode', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Vendor Batch Code
                    <SortIndicator columnKey="vendorBatchCode" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'stocktype' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('stocktype', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Stock Type
                    <SortIndicator columnKey="stocktype" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'date' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('date', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Date
                    <SortIndicator columnKey="date" currentSortConfig={sortConfig} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'cost' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('cost', setSortConfig, sortConfig)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Price
                    <SortIndicator columnKey="cost" currentSortConfig={sortConfig} />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentPageData.map((row) => (
                <tr
                  key={row.sid}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${hoveredRow === row.sid ? (isMobile ? '' : 'UI-table-row-hovered') : ''}`}
                  onClick={() => handleselect(row.sid, row.name)}
                  onMouseEnter={() => setHoveredRow(row.sid)}
                  onMouseLeave={() => {
                    setHoveredRow(null);
                    setHoveredAction(null);
                  }}
                >
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.name, searchTerm)}</td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(
                      row.stockfrom === "Production"
                        ? "Production"
                        : !row.supplier
                          ? "Opening"
                          : row.supplier,
                      searchTerm
                    )}
                  </td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.brand || "NA", searchTerm)}</td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.model || "NA", searchTerm)}</td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.warehouse, searchTerm)}</td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{
                    color: row.currentStock < 3 ? "red" : "green",
                    fontWeight: hoveredRow === row.sid ? 600 : 400,
                  }}>
                    {highlightSearchText(row.currentStock?.toString(), searchTerm)}
                  </td>
                  {/* NEW: Vendor Batch Code Cell */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(row.vendorBatchCode || "N/A", searchTerm)}
                  </td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(STOCKTYPE_LABELS[row.stocktype] ?? row.stocktype, searchTerm)}</td>
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(moment(row.date).format("DD-MM-YYYY HH:mm"), searchTerm)}</td>
                  <td className={`UI-td UI-price-high ${isMobile ? 'UI-td-mobile' : ''}`}>
                    {highlightSearchText(
                      formatCurrencyAsString(row.cost),
                      searchTerm
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {renderPagination()}
      </>
    );
  };

  // Get sorted itemstock for Stock Details table
  const getSortedItemStock = () => {
    return getSortedData(itemstock, sortConfigStockDetails);
  };

  const StockDetailsTable = () => {
    const sortedItemStock = getSortedItemStock();

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('supplier', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Supplier
                  <SortIndicator columnKey="supplier" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'warehouse' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('warehouse', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Org Unit
                  <SortIndicator columnKey="warehouse" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'custombatchid' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('custombatchid', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Batch Id
                  <SortIndicator columnKey="custombatchid" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              {/* NEW: Vendor Batch Code Column */}
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'vendorBatchCode' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('vendorBatchCode', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Vendor Batch Code
                  <SortIndicator columnKey="vendorBatchCode" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'addedStock' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('addedStock', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Added Stock
                  <SortIndicator columnKey="addedStock" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'consumedStock' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('consumedStock', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Consumed Stock
                  <SortIndicator columnKey="consumedStock" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'batchstock' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('batchstock', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Current Stock
                  <SortIndicator columnKey="batchstock" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'stocktype' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('stocktype', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Stock Type
                  <SortIndicator columnKey="stocktype" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'stockfrom' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('stockfrom', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Stock From
                  <SortIndicator columnKey="stockfrom" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'date' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('date', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <SortIndicator columnKey="date" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockDetails.key === 'rate' ? 'UI-th-sorted' : ''}`}
                onClick={() => sortData('rate', setSortConfigStockDetails, sortConfigStockDetails)}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Price
                  <SortIndicator columnKey="rate" currentSortConfig={sortConfigStockDetails} />
                </div>
              </th>
              <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${(inventoryid === "2" || inventoryid === "3") ? '' : 'UI-hidden'}`}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedItemStock.map((row) => (
              <tr
                key={row.sid}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${hoveredRow === row.sid ? (isMobile ? '' : 'UI-table-row-hovered') : ''}`}
                onMouseEnter={() => setHoveredRow(row.sid)}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.stockfrom === "Production" ? "Production" : (row.supplier === undefined || row.supplier === null || row.supplier === "" ? "Opening" : row.supplier), searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.waddress, searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.custombatchid, searchTerm)}</td>
                {/* NEW: Vendor Batch Code Cell */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {highlightSearchText(row.vendorBatchCode || "N/A", searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ color: "green" }}>{highlightSearchText(row.addedStock?.toString(), searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ color: row.consumedStock > 0 ? "red" : "green" }}>{highlightSearchText(row.consumedStock?.toString(), searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ color: row.batchstock < 3 ? "red" : "green" }}>
                  {highlightSearchText(row.batchstock?.toString(), searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(STOCKTYPE_LABELS[row.stocktype] ?? row.stocktype, searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(row.stockfrom, searchTerm)}</td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>{highlightSearchText(moment(row.date).format("DD-MM-YYYY HH:mm"), searchTerm)}</td>
                <td className={`UI-td UI-price-high ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {highlightSearchText(
                    formatCurrencyAsString(row.rate),
                    searchTerm
                  )}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} ${(inventoryid === "2" || inventoryid === "3") ? '' : 'UI-hidden'}`}>
                  {row.stockfrom === "Direct" && row.addedStock === row.batchstock ? (
                    <Link
                      to={{
                        pathname: "/addstock",
                      }}
                      state={{
                        id: row.sid,
                        pagename: "Update Stock",
                        data: row,
                        stocktype: "Own"
                      }}
                      className="UI-edit-link"
                      onMouseEnter={() => setHoveredAction(`editStock-${row.sid}`)}
                      onMouseLeave={() => setHoveredAction(null)}
                    >
                      <Tooltip
                        title="Update Stock"
                        arrow
                        slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}
                        open={hoveredAction === `editStock-${row.sid}`}
                      >
                        <img
                          src={EditIcon}
                          alt="Edit Stock"
                          className={`UI-cost-edit-icon-list ${isMobile ? 'UI-cost-edit-icon-list-mobile' : ''} ${hoveredAction === `editStock-${row.sid}` ? 'UI-cost-edit-icon-list-hover' : ''}`}
                        />
                      </Tooltip>
                    </Link>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // Render pagination controls
  const renderPagination = () => {
    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} items
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${hovered === 'pageSize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => setHovered('pageSize')}
            onMouseLeave={() => setHovered(null)}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && setHovered('first')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && setHovered('prev')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && setHovered('next')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && setHovered('last')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  };

  const renderStockTypeTabs = () => {
    return (
      <div className="d-flex gap-2 m-2">
        <fieldset
          className={`UI-tab-button ${stocktype === "Own Stock" ? "UI-active-tab" : "UI-inactive-tab"}`}
          onClick={() => {
            setStocktype("Own Stock");
            setSortConfig({ key: 'name', direction: 'asc' });
            setCurrentPage(1);
          }}
          style={{ cursor: "pointer" }}
        >
          Own Stock
          <img
            src={UpArrow}
            alt="Up Arrow"
            className="UI-tab-arrow"
            style={{
              transform: stocktype === "Own Stock" ? "rotate(30deg)" : "rotate(0deg)",
            }}
          />
        </fieldset>

        <fieldset
          className={`UI-tab-button ${stocktype === "Third Party Stock" ? "UI-active-tab" : "UI-inactive-tab"}`}
          onClick={() => {
            setStocktype("Third Party Stock");
            setSortConfig({ key: 'name', direction: 'asc' });
            setCurrentPage(1);
          }}
          style={{ cursor: "pointer" }}
        >
          Third Party Stock
          <img
            src={UpArrow}
            alt="Up Arrow"
            className="UI-tab-arrow"
            style={{
              transform: stocktype === "Third Party Stock" ? "rotate(30deg)" : "rotate(0deg)",
            }}
          />
        </fieldset>
      </div>
    );
  };

  const renderListView = () => {
    return (
      <>
        {stocktype === "Own Stock" ? <MainTable /> : <ThirdPartyTable />}
      </>
    );
  };

  const renderDetailView = () => {
    if (!selectedStock) return null;

    const sortedBatchData = getSortedBatchData();

    return (
      <div className="UI-detail-view">
        {/* Sidebar with stock list */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${isBackHovered ? 'UI-back-button-hover' : ''}`}
              onClick={handleBackToList}
              onMouseEnter={() => setIsBackHovered(true)}
              onMouseLeave={() => setIsBackHovered(false)}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>

          <div className="UI-sidebar-list" ref={sidebarRef}>
            {filteredSidebarData.map(item => (
              <div
                key={item.id}
                data-stock-id={item.id}
                className={`UI-sidebar-item ${selectedStock.id === item.id ? 'UI-sidebar-item-active' : ''} ${hovered === item.id ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => handleselect(item.id, item.name)}
                onMouseEnter={() => setHovered(item.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div className={`UI-sidebar-item-name ${hovered === item.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {highlightSearchText(item.name, searchTerm)}
                </div>
                <div className={`UI-sidebar-item-code ${hovered === item.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  Stock: {highlightSearchText(item.totalStock?.toString(), searchTerm)} {item.uomname}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">{highlightSearchText(itemname, searchTerm)}</h2>
              <p className="UI-detail-subtitle">
                Stock Details
              </p>
            </div>

            {/* Original Stock Details/Consumption Tabs with Arrows */}
            <div className="d-flex gap-2">
              <fieldset
                className={`UI-tab-button ${type === "Stock Details" ? "UI-active-tab" : "UI-inactive-tab"}`}
                onClick={() => setType("Stock Details")}
                style={{ cursor: "pointer" }}
              >
                Stock Details
                <img
                  src={UpArrow}
                  alt="Up Arrow"
                  className="UI-tab-arrow"
                  style={{
                    transform: type === "Stock Details" ? "rotate(30deg)" : "rotate(0deg)",
                  }}
                />
              </fieldset>
              <fieldset
                className={`UI-tab-button ${type === "Stock Consumption" ? "UI-active-tab" : "UI-inactive-tab"}`}
                onClick={() => setType("Stock Consumption")}
                style={{ cursor: "pointer" }}
              >
                Stock Consumption
                <img
                  src={UpArrow}
                  alt="Up Arrow"
                  className="UI-tab-arrow"
                  style={{
                    transform: type === "Stock Consumption" ? "rotate(30deg)" : "rotate(0deg)",
                  }}
                />
              </fieldset>
            </div>
          </div>

          {type === "Stock Details" ? (
            <StockDetailsTable />
          ) : (
            <>
              {/* Updated Date Filter Design - Matching QuotationTable */}
              <div className="UI-date-filter-container" style={{
                backgroundColor: '#f8fafc',
                borderBottom: '1px solid #e2e8f0',
                padding: '12px 20px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: '16px'
              }}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontSize: '0.875rem', fontWeight: '500' }}>Date Range:</span>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From Date"
                      value={fromdate}
                      onChange={handleFromDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          style={{ width: '140px' }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To Date"
                      value={todate}
                      onChange={handleToDateChange}
                      minDate={fromdate}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          style={{ width: '140px' }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={Submit}
                  onMouseEnter={() => setHovered('apply')}
                  onMouseLeave={() => setHovered(null)}
                >
                  <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
                  Apply
                </button>
              </div>

              <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
                <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
                  <thead className="UI-table-header">
                    <tr>
                      <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}></th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'custombatchid' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('custombatchid', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Batch
                          <SortIndicator columnKey="custombatchid" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      {/* NEW: Vendor Batch Code Column */}
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'vendorBatchCode' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('vendorBatchCode', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Vendor Batch Code
                          <SortIndicator columnKey="vendorBatchCode" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('supplier', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Supplier
                          <SortIndicator columnKey="supplier" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'addedStock' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('addedStock', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Added Stock
                          <SortIndicator columnKey="addedStock" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'currentStock' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('currentStock', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Current Stock
                          <SortIndicator columnKey="currentStock" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'stocktype' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('stocktype', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Stock Type
                          <SortIndicator columnKey="stocktype" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'rate' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('rate', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Price
                          <SortIndicator columnKey="rate" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'stockfrom' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('stockfrom', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Stock From
                          <SortIndicator columnKey="stockfrom" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      >
                        Purchase Order Id/ GRN Id
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'warehouse' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('warehouse', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Warehouse
                          <SortIndicator columnKey="warehouse" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfigStockConsumption.key === 'date' ? 'UI-th-sorted' : ''}`}
                        onClick={() => sortData('date', setSortConfigStockConsumption, sortConfigStockConsumption)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="UI-th-content">
                          Date
                          <SortIndicator columnKey="date" currentSortConfig={sortConfigStockConsumption} />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedBatchData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, idx) => (
                        <Row
                          key={idx}
                          row={row}
                          salesconsumptiondata={salesconsumptiondata.filter(e => e.batchid === row.batchid)}
                          productionconsumptiondata={productionconsumptiondata.filter(e => e.batchid === row.batchid)}
                        />
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="UI-pagination-info">
                  {batchstockdata.length === 0 ? (
                    "No Entries"
                  ) : (
                    `Showing ${page * rowsPerPage + 1} to ${Math.min((page + 1) * rowsPerPage, batchstockdata.length)} of ${batchstockdata.length} entries`
                  )}
                </span>
                <div className="d-flex ">
                  <button
                    onClick={() => setPage(Math.max(0, page - 1))}
                    disabled={page === 0}
                    className={`UI-btn UI-btn-outline mr-2 ${page === 0 ? 'opacity-50' : ''} ${hovered === "prevPage" ? 'UI-btn-outline-hover' : ''}`}
                    onMouseEnter={() => setHovered("prevPage")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => setPage(Math.min(Math.ceil(batchstockdata.length / rowsPerPage) - 1, page + 1))}
                    disabled={page >= Math.ceil(batchstockdata.length / rowsPerPage) - 1}
                    className={`UI-btn UI-btn-outline ${page >= Math.ceil(batchstockdata.length / rowsPerPage) - 1 ? 'opacity-50' : ''} ${hovered === "nextPage" ? 'UI-btn-outline-hover' : ''}`}
                    onMouseEnter={() => setHovered("nextPage")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
      <div className="UI-card">
        {/* Header */}
        <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Stocks",path:null}]}/>

          <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
            <div>
              <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                Stock Management
              </h1>
              <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                {currentView === 'detail' && selectedStock
                  ? `Item: ${selectedStock.name}`
                  : 'Manage and track your inventory stock levels'
                }
              </p>
            </div>

            <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
              {/* Mobile Search */}
              {isMobile && (
                <input
                  type="text"
                  placeholder="Search stock items..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="UI-mobile-search-input"
                />
              )}

              <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                {/* Desktop Search Toggle */}
                {!isMobile && (
                  <div
                    className={`UI-search-container ${showSearch ? 'UI-search-container-expanded' : ''} ${hovered === "search" ? 'UI-search-container-hover' : ''}`}
                    onClick={() => {
                      if (!showSearch) setShowSearch(true);
                    }}
                    onMouseEnter={() => setHovered("search")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <i className="fa fa-search UI-search-icon" />
                    {!showSearch && "Search"}
                    {showSearch && (
                      <input
                        type="text"
                        placeholder="Search stock items..."
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                        className="UI-search-input"
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => {
                          if (searchTerm.trim() === "") {
                            setShowSearch(false);
                          }
                        }}
                      />
                    )}
                  </div>
                )}

                {/* Add Stock button */}
                {(inventoryid === "2" || inventoryid === "3") && (
                  <Link
                    to={{ pathname: "/addstock" }}
                    state={{
                      id: -1,
                      pagename: stocktype === "Own Stock" ? "Add Stock" : "ThirdParty Stock",
                      data: undefined,
                      stocktype: stocktype === "Own Stock" ? "Own" : "ThirdParty"
                    }}
                    className={`UI-btn UI-btn-primary ${isMobile ? 'UI-btn-mobile' : ''} ${hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                    onMouseEnter={() => setHovered("new")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <i className="fa fa-plus" />
                    {isMobile ? "Add" : (stocktype === "Own Stock" ? "Add Stock" : "Add Third Party Stock")}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="UI-loading-container">
            {spin}
          </div>
        ) : (
          <>
            {/* Always show stock type tabs */}
            {currentView === 'list' && renderStockTypeTabs()}

            {/* Switch between list and detail view */}
            {currentView === 'list'
              ? renderListView()
              : renderDetailView()
            }
          </>
        )}
      </div>
    </div>
  );
};

export default withRouter(StockDataTable);